export const Button = ({
  handleClick,
  text,
  cx,
}: {
  handleClick: () => void;
  text: string;
  cx?: string;
}) => {
  return (
    <div
      className={`min-[409px]:max-w-[373px] mx-auto max-[409px]:px-[18px] flex items-center justify-center ${cx}`}
    >
      <button
        onClick={handleClick}
        className="border w-full border-light-text-tertiary px-[18px] py-[14px] rounded-full"
      >
        <p className="text-light-text-tertiary text-sm font-bold">{text}</p>
      </button>
    </div>
  );
};
